// extracted by mini-css-extract-plugin
export default {"inputWrapper":"inputWrapper--rGLKX","html-input-label-actions":"html-input-label-actions--RMP5O"};